import styled from 'styled-components';
import { getGridSpans, getSpace } from '../../../stylesheets/tools';

const StyledTagsList = styled.div`
  .tagList__wrapper {
    ${getGridSpans('width', { s: 12, l: 8 })}
    ${getGridSpans('margin-left', { s: 0, l: [2, 'spread'] })}
  }

  .tagList__headline {
    margin-bottom: ${getSpace('xxs')};
  }
`;

export default StyledTagsList;
